function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "hotdog-mini-gradient",
  cx: -774.94,
  cy: 1237.79,
  r: 2.23,
  gradientTransform: "matrix(-0.03, 1.02, -0.87, -0.01, 1080.63, 820.49)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 0.26,
  stopColor: "#fdfdfd"
}), React.createElement("stop", {
  offset: 0.4,
  stopColor: "#f5f5f5"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#e7e7e7"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#d4d4d4"
}), React.createElement("stop", {
  offset: 0.68,
  stopColor: "#bbb"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#9c9c9c"
}), React.createElement("stop", {
  offset: 0.83,
  stopColor: "#787878"
}), React.createElement("stop", {
  offset: 0.9,
  stopColor: "#4d4d4d"
}), React.createElement("stop", {
  offset: 0.96,
  stopColor: "#1f1f1f"
}), React.createElement("stop", {
  offset: 1
})), React.createElement("radialGradient", {
  id: "b",
  cx: -766.67,
  cy: 1237.23,
  r: 2.23,
  gradientTransform: "matrix(-0.03, 1.02, -0.87, -0.01, 1092.53, 811.53)",
  xlinkHref: "#hotdog-mini-gradient"
}));

var SvgHotdogMini = function SvgHotdogMini(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 56 71",
    ref: svgRef
  }, props), _ref2, React.createElement("rect", {
    className: "coat",
    x: 5.82,
    y: 9.29,
    width: 40.04,
    height: 60.57,
    rx: 20.02,
    transform: "translate(0.18 -0.12) rotate(0.26)",
    style: {
      fill: "#dbcb86",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), React.createElement("path", {
    className: "arm armLeft",
    d: "M39.87,21.85l7.59,4.25a4.2,4.2,0,0,1,1.9-.56c1.14-.05,1.51.4,1.51.4l2.38-.35a1.11,1.11,0,0,1,.93.29,5.34,5.34,0,0,1,.87,2.45,2.56,2.56,0,0,1-.68,1.75c-.27.41-.63,1.23-1.23,1.29a14.27,14.27,0,0,1-3.12-1s1.54,1.93.73,2.41-1.67.07-2.1-.93a5.59,5.59,0,0,1-1.86-1.26,4.72,4.72,0,0,1-.51-2.47l-7.66-4.31L34.7,27.59l-2.94-.17,5.64-5.85S38.4,20,39.87,21.85Z",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeLinejoin: "round",
      strokeWidth: "0.74435156583786px"
    }
  }), React.createElement("path", {
    className: "arm armRight",
    d: "M8.7,27.9,5.65,36a4.1,4.1,0,0,0-1.81.8c-.91.69-.9,1.28-.9,1.28l-2,1.27a1.14,1.14,0,0,0-.53.82,5.37,5.37,0,0,0,.92,2.43,2.58,2.58,0,0,0,1.65.9c.47.14,1.28.53,1.78.19A14.19,14.19,0,0,0,6.46,41s.07,2.47,1,2.31,1.32-1,1-2.06a5.62,5.62,0,0,0,.61-2.16,4.67,4.67,0,0,0-1.2-2.22s2.1-5.32,3.05-7.9l6.51-2.12-1.16-2.48L9.39,26.46S8.81,26.66,8.7,27.9Z",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeLinejoin: "round",
      strokeWidth: "0.74435156583786px"
    }
  }), React.createElement("rect", {
    className: "body",
    x: 15.57,
    y: 0.36,
    width: 20.15,
    height: 64.47,
    rx: 10.08,
    transform: "translate(0.15 -0.12) rotate(0.26)",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeMiterlimit: 10,
      strokeWidth: "0.728445275609033px"
    }
  }), React.createElement("g", {
    className: "eye eyeRight"
  }, React.createElement("path", {
    className: "sclera",
    d: "M25.73,16.35A5.47,5.47,0,0,1,20,21.51a5.49,5.49,0,0,1-5.73-5.2A5.49,5.49,0,0,1,20,11.15,5.47,5.47,0,0,1,25.73,16.35Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    className: "pupil",
    d: "M23.31,16.54a3.26,3.26,0,1,1-3.25-3.3A3.26,3.26,0,0,1,23.31,16.54Z",
    style: {
      fill: "url(#hotdog-mini-gradient)"
    }
  })), React.createElement("g", {
    className: "eye eyeLeft"
  }, React.createElement("path", {
    className: "sclera",
    d: "M37.89,15.83A5.49,5.49,0,0,1,32.12,21a5.48,5.48,0,0,1-5.72-5.21,5.48,5.48,0,0,1,5.76-5.16A5.5,5.5,0,0,1,37.89,15.83Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    className: "pupil",
    d: "M35.46,16a3.26,3.26,0,1,1-3.25-3.3A3.26,3.26,0,0,1,35.46,16Z",
    style: {
      fill: "url(#b)"
    }
  })), React.createElement("path", {
    className: "mouth",
    d: "M29.45,26.13s.76-4.47-3.64-4.32c-3.34.11-3,4.5-3,4.5Z",
    style: {
      fill: "#010101"
    }
  }), React.createElement("path", {
    className: "ketchup",
    d: "M25.77,32.67c-1.83,1.58-4.59,2.3-5,5-.58,3.91,3.35,4.61,5.41,6.8,4.2,4.44-5.36,6-5.86,10.37-.41,3.48,3.25,5.58,5.86,6.89,1.48.75,2.79-1.48,1.3-2.23-3-1.51-6.26-3-2.49-6.77.85-.86,2.29-1.21,3.21-2,1.49-1.26,2.57-2.9,2.12-4.95-.55-2.43-2.41-2.77-3.85-4.28-3.57-3.78-1.3-5,1.13-7.07,1.27-1.08-.57-2.9-1.83-1.82Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("path", {
    className: "eyebrow eyebrowRight",
    d: "M20.67,7.17a3.66,3.66,0,0,1-1.26,3,2.85,2.85,0,0,1-3,.2",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.30540463174261px"
    }
  }), React.createElement("path", {
    className: "eyebrow eyebrowLeft",
    d: "M29.92,7.3a3.69,3.69,0,0,0,1.94,2.64,2.85,2.85,0,0,0,2.92-.51",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.30540463174261px"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHotdogMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotdog-mini.7a12f94f.svg";
export { ForwardRef as ReactComponent };